export default "__VITE_ASSET__e7492afa__$_?nuxt_component=async__"